import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import '../@style/UyumPage.css';

const Uyum = () => {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();

  const pdfDocuments = [
    {
      id: 1,
      titleKey: "compliance.documents.doc1",
      filename: "1- MASGOLD BORSA ÜYELİK BELGESİ.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 2,
      titleKey: "compliance.documents.doc2",
      filename: "2- MASGOLD MÜŞTERİ TANIMA FORMU.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 3,
      titleKey: "compliance.documents.doc3",
      filename: "3- MASGOLD MÜŞTERİ KABUL BEYANI.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 4,
      titleKey: "compliance.documents.doc4",
      filename: "4- MASGOLD İÇ KONTROL SİSTEMİ VE TEDARİK ZİNCİRİ UYUM PROĞRAMI.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 5,
      titleKey: "compliance.documents.doc5",
      filename: "5- MASGOLD KIYMETLİ MADENLER SORUMLU TEDARİK ZİNCİRİ UYUM POLİTİKASI.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 6,
      titleKey: "compliance.documents.doc6",
      filename: "6- MASGOLD SORUMLU TEDARİK ZİNCİRİ UYGULAMA TALİMATI.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 7,
      titleKey: "compliance.documents.doc7",
      filename: "7- LBMA Sorumlu Altın Rehberi Dökümü.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 8,
      titleKey: "compliance.documents.doc8",
      filename: "8- -MASAK UYUM YÖNETMELİĞİ.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 9,
      titleKey: "compliance.documents.doc9",
      filename: "9- 2023_Kiymetli_Madenler_Sorumlu_Tedarik_Zinciri.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 10,
      titleKey: "compliance.documents.doc10",
      filename: "10 30 06 BAĞIMSIZ GÜVENCE RAPORU.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 11,
      titleKey: "compliance.documents.doc11",
      filename: "11 30 06 SORUMLU TEDARİK ZİNCİRİ YÖNETİM RAPORU.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 12,
      titleKey: "compliance.documents.doc12",
      filename: "12 30 06 YÖNETİM KURULU KARARI 25.03.2024.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 13,
      titleKey: "compliance.documents.doc13",
      filename: "13 30 06 YÖNETIM KURULU KARARI.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 14,
      titleKey: "compliance.documents.doc14",
      filename: "14 24.03.2025 YÖNETİM KURULU KARARI UYUM RAPORU.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 15,
      titleKey: "compliance.documents.doc15",
      filename: "15 2024 YILI  KIYMETLİ MADENLER SORUMLU TEDARİK ZİNCİRİ UYUM RAPORU.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 16,
      titleKey: "compliance.documents.doc16",
      filename: "16 2024 YILI BAĞIMSIZ GÜVENCE RAPORU.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 17,
      titleKey: "compliance.documents.doc17",
      filename: "17 2024 YILI STZ YÖNETİM RAPORU.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 18,
      titleKey: "compliance.documents.doc18",
      filename: "18 2024 YILI UYUM VE GÜVENCE RAPORU YK.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 19,
      titleKey: "compliance.documents.doc19",
      filename: "2025 YILI STZ UYUM RAPORU.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 20,
      titleKey: "compliance.documents.doc20",
      filename: "2025 YILI  STZ UYUM RAPORU YK.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 21,
      titleKey: "compliance.documents.doc21",
      filename: "Stz Yönetim Raporu 2025.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 22,
      titleKey: "compliance.documents.doc22",
      filename: "2025 BAĞIMSIZ GüvenceRaporu.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 23,
      titleKey: "compliance.documents.doc23",
      filename: "2025 BAĞIMSIZ GÜVENCE RAPORU YK.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 24,
      titleKey: "compliance.documents.doc24",
      filename: "YÖNETİM KURULU KARARI 01.06.2026.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 25,
      titleKey: "compliance.documents.doc25",
      filename: "ANTI-BRIBERY AND ANTI-CORRUPTION POLICY.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 26,
      titleKey: "compliance.documents.doc26",
      filename: "İÇ KONTROL SİSTEMİ VE TEDARİK ZİNCİRİ UYUM PROGRAMI.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 27,
      titleKey: "compliance.documents.doc27",
      filename: "İHBAR VE BİLGİ UÇURMA POLİTİKASI.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 28,
      titleKey: "compliance.documents.doc28",
      filename: "INTERNAL CONTROL SYSTEM AND SUPPLY CHAIN COMPLIANCE PROGRAMME.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 29,
      titleKey: "compliance.documents.doc29",
      filename: "KIYMETLİ MADEN ALIM-SATIM ÇERÇEVE SÖZLEŞMESİ.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 30,
      titleKey: "compliance.documents.doc30",
      filename: "KIYMETLİ MADENLER SORUMLU TEDARİK ZİNCİRİ UYUM POLİTİKASI.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 31,
      titleKey: "compliance.documents.doc31",
      filename: "KIYMETLİ MADENLER SORUMLU TEDARİK ZİNCİRİ UYGULAMA TALİMATI.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 32,
      titleKey: "compliance.documents.doc32",
      filename: "MÜŞTERİ KABUL BEYANİ.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 33,
      titleKey: "compliance.documents.doc33",
      filename: "MÜŞTERİNİ TANI FORMU — GERÇEK KİŞİ.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 34,
      titleKey: "compliance.documents.doc34",
      filename: "MÜŞTERİNİ TANI FORMU — TÜZEL KİŞİ.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 35,
      titleKey: "compliance.documents.doc35",
      filename: "POLICY ON THE PREVENTION OF MONEY LAUNDERING AND THE FINANCING OF TERRORISM.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 36,
      titleKey: "compliance.documents.doc36",
      filename: "PRECIOUS METALS RESPONSIBLE SUPPLY CHAIN COMPLIANCE POLICY.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 37,
      titleKey: "compliance.documents.doc37",
      filename: "RÜŞVET VE YOLSUZLUKLA MÜCADELE POLİTİKASI.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 38,
      titleKey: "compliance.documents.doc38",
      filename: "SUÇ GELİRLERİNİN AKLANMASININ VE TERÖRÜN FİNANSMANININ ÖNLENMESİ HAKKINDA ŞİRKET POLİTİKASI.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 39,
      titleKey: "compliance.documents.doc39",
      filename: "WHISTLEBLOWING POLICY.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 40,
      titleKey: "compliance.documents.doc40",
      filename: "Faaliyet_Belgesi 11.05.2026.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 41,
      titleKey: "compliance.documents.doc41",
      filename: "MASGOLD 2025 VERGİ LEVHASI YENİ ÜNVAN.pdf",
      categoryKey: "compliance.documents.category"
    },
    {
      id: 42,
      titleKey: "compliance.documents.doc42",
      filename: "MASGOLD İMZA SİRKÜSÜ 26.03.2029.S.pdf",
      categoryKey: "compliance.documents.category"
    }
  ];

  const handlePdfClick = (filename) => {
    const pdfPath = `/masgoldpdf/${encodeURIComponent(filename)}`;
    window.open(pdfPath, '_blank');
  };

  return (
    <div className={`uyum-page ${isDarkMode ? 'dark-mode' : ''}`}>
      <div className="container">
        <div className="page-header">
          <h1 className="page-title">{t('compliance.title')}</h1>
          <p className="page-subtitle">
            {t('compliance.subtitle')}
          </p>
        </div>


        <div className="documents-section">
          <h2 className="section-title">{t('compliance.documents.title')}</h2>
          <div className="documents-grid">
            {pdfDocuments.map((doc) => (
              <div 
                key={doc.id} 
                className="document-card"
                onClick={() => handlePdfClick(doc.filename)}
              >
                <div className="document-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="document-content">
                  <h3 className="document-title">{t(doc.titleKey)}</h3>
                  <span className="document-category">{t(doc.categoryKey)}</span>
                </div>
                <div className="document-arrow">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 17L17 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M7 7H17V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Uyum;
